import { useState } from "react";
import styled from "styled-components";
import PostCode from "../../../common/postcode";
import KakaoMap from "../../map/Maptainer";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 31;
  width: 100vw;
  height: 100vh;

  .modal-section {
    position: fixed;
    top: 54%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 20px;
    width: 35rem;
    overflow-x: hidden;
    z-index: 32;
    border: none;
    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      position: fixed;
      top: 3%;
      right: 3%;
      z-index: 33;
      :hover {
        color: #3bb77e;
      }
    }

    @media (max-width: 960px) {
      width: 90%;
    }
  }

  .modal-header {
    width: 100%;
    margin-top: 1rem;
    padding-left: 2rem;
    font-size: 1.2rem;
    font-weight: 500;
    color: black;
  }

  .modal-content {
    height: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem;
    border: none;
    overflow-y: auto;
    & span {
      color: black;
    }
    z-index: 33;
  }
`;

const ModalContentRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ModalContentCol = styled.div`
  width: 100%;
  height: auto;
  padding-right: 5%;
  padding-bottom: 1rem;
  padding-left: 5%;
  display: flex;
  align-items: center;

  .zipcode {
    width: 39%;
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    width: 30%;
    height: 38px;
    margin-left: 1%;
    word-break: keep-all;
    border-radius: 10px;
  }

  @media (max-width: 960px) {
    width: 100%;
    border: 0;
    margin-right: 0;
  }

  & h6 {
    display: flex;
    align-items: center;
    width: 30%;
    font-weight: 400;
    margin-bottom: 10px;
  }

  & input {
    width: 70%;
    height: 2.3rem;
  }
`;

const ComfirmBtnWrapper = styled.div`
  width: 100%;
  height: 3rem;
  display: flex;
  justify-content: center;

  & button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const AddressModal = (props) => {
  const [postOpen, setPostOpen] = useState(false);
  const [pickAddress, setPickAddress] = useState({
    address: "",
  });

  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return props.setIsOpen(false);
  };

  // 우편번호 검색
  const handlePostModal = () => {
    setPostOpen((prev) => !prev);
  };

  const onCompleteAddressCode = (postcode) => {
    setPickAddress(postcode);
    props.reset({ zipcode: postcode.zonecode });
    props.reset({
      doro_addr: pickAddress.roadAddress
        ? pickAddress.roadAddress
        : pickAddress.autoRoadAddress,
    });
    props.reset({
      base_addr: pickAddress.jibunAddress
        ? pickAddress.jibunAddress
        : pickAddress.autoJibunAddress,
    });
    setPostOpen(false);
  };

  return (
    <>
      <ModalWrapper>
        <form
          onSubmit={props.handleSubmit((data) => props.createAddress(data))}
        >
          <div className="modal-section">
            <div className="modal-header">배송지 등록</div>
            <i
              className="fi-rs-cross-circle"
              onClick={() => props?.setIsOpen(false)}
            />
            <div className="modal-content">
              <ModalContentRow>
                <ModalContentCol>
                  <h6>배송지 이름</h6>
                  <input type={"text"} {...props.register("addr_name")} />
                </ModalContentCol>
                <ModalContentCol>
                  <h6>우편번호</h6>
                  <input
                    className="zipcode"
                    type={"text"}
                    readOnly
                    defaultValue={pickAddress.zonecode}
                    {...props.register("zipcode")}
                  />
                  <div className="btn" onClick={handlePostModal}>
                    주소 검색
                  </div>
                </ModalContentCol>
                <ModalContentCol>
                  <h6>도로명 주소</h6>
                  <input
                    type={"text"}
                    readOnly
                    defaultValue={
                      pickAddress.roadAddress
                        ? pickAddress.roadAddress
                        : pickAddress.autoRoadAddress
                    }
                    {...props.register("doro_addr")}
                  />
                </ModalContentCol>
                <ModalContentCol>
                  <h6>지번 주소</h6>
                  <input
                    type={"text"}
                    readOnly
                    defaultValue={
                      pickAddress.jibunAddress
                        ? pickAddress.jibunAddress
                        : pickAddress.autoJibunAddress
                    }
                    {...props.register("base_addr")}
                  />
                </ModalContentCol>
                <ModalContentCol>
                  <h6>상세 주소</h6>
                  <input
                    type={"text"}
                    placeholder="상세주소 입력"
                    {...props.register("detail_addr")}
                  />
                </ModalContentCol>
              </ModalContentRow>
              <ComfirmBtnWrapper>
                <button type={"submit"}>등록하기</button>
              </ComfirmBtnWrapper>
            </div>
          </div>
        </form>
      </ModalWrapper>
      {postOpen && (
        <PostCode
          onClickHandleModal={handlePostModal}
          onCompletePostCode={onCompleteAddressCode}
        />
      )}
      <div style={{ diplay: "none" }}>
        <KakaoMap
          address={pickAddress.address}
          setUserInputs={props.setMapInputs}
          userinputs={props.mapInputs}
        />
      </div>
    </>
  );
};
export default AddressModal;
